export const SWITCH_LANGUAGE = "SWITCH_LANGUAGE";
export const TOGGLE_COLLAPSED_NAV = "TOGGLE_COLLAPSED_NAV";
export const TOGGLE_COLLAPSED_LANG = "TOGGLE_COLLAPSED_LANG";
export const TOGGLE_COLLAPSED_MEMBER_MENU = "TOGGLE_COLLAPSED_MEMBER_MENU";
export const SET_MENU_FOOTER_ACTIVE = "SET_MENU_FOOTER_ACTIVE";
export const COLLAPSED_ALL_MENU = "COLLAPSED_ALL_MENU";

export const LANGUAGE_CLOSE_POPUP = "LANGUAGE_CLOSE_POPUP";
export const LANGUAGE_OPEN_POPUP = "LANGUAGE_OPEN_POPUP";
export const LANGUAGE_CHANGE_SUCCESS = "LANGUAGE_CHANGE_SUCCESS";

export const HIDE_MESSAGE = "HIDE_MESSAGE";
export const ON_HIDE_LOADER = "ON_HIDE_LOADER";
export const ON_SHOW_LOADER = "ON_SHOW_LOADER";
export const SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE";
export const SHOW_WARNING_MESSAGE = "SHOW_WARNING_MESSAGE";
export const SHOW_SUCCESS_MESSAGE = "SHOW_SUCCESS_MESSAGE";
export const SHOW_INFO_MESSAGE = "SHOW_INFO_MESSAGE";

export const AUTH_CHECK_TOKEN = "AUTH_CHECK_TOKEN";
export const AUTH_FETCH_SUCCESS = "AUTH_FETCH_SUCCESS";
export const AUTH_SIGNIN = "AUTH_SIGNIN";
export const AUTH_SIGNIN_SUCCESS = "AUTH_SIGNIN_SUCCESS";
export const AUTH_SIGNOUT = "AUTH_SIGNOUT";
export const AUTH_SIGNOUT_SUCCESS = "AUTH_SIGNOUT_SUCCESS";
export const AUTH_CLOSE_POPUP = "AUTH_CLOSE_POPUP";
export const AUTH_OPEN_POPUP = "AUTH_OPEN_POPUP";
export const AUTH_PROFILE_FETCH = "AUTH_PROFILE_FETCH";
export const AUTH_PROFILE_FETCH_SUCCESS = "AUTH_PROFILE_FETCH_SUCCESS";
export const MEMBER_PROFILE_FETCH = "MEMBER_PROFILE_FETCH";
export const MEMBER_PROFILE_FETCH_SUCCESS = "MEMBER_PROFILE_FETCH_SUCCESS";
export const MEMBER_PROFILE_UPDATE = "MEMBER_PROFILE_UPDATE";
export const MEMBER_PROFILE_CHANGE_PASSWORD = "MEMBER_PROFILE_CHANGE_PASSWORD";
export const PDPA_REQUEST = "PDPA_REQUEST";
export const PDPA_REQUEST_SUCCESS = "PDPA_REQUEST_SUCCESS";



export const CATEGORIES_FETCH = "CATEGORIES_FETCH";
export const CATEGORIES_FETCH_SUCCESS = "CATEGORIES_FETCH_SUCCESS";

export const PRIVILEGE_FETCH = "PRIVILEGE_FETCH";
export const PRIVILEGE_FETCH_SUCCESS = "PRIVILEGE_FETCH_SUCCESS";
export const PRIVILEGES_FETCH = "PRIVILEGES_FETCH";
export const PRIVILEGES_FETCH_SUCCESS = "PRIVILEGES_FETCH_SUCCESS";
export const PRIVILEGES_FETCH_ALL = "PRIVILEGES_FETCH_ALL";


export const FAQS_FETCH = "FAQS_FETCH";
export const FAQS_FETCH_SUCCESS = "FAQS_FETCH_SUCCESS";

export const CONTACT_REQUEST = "CONTACT_REQUEST";
export const CONTACT_REQUEST_SUCCESS = "CONTACT_REQUEST_SUCCESS";

export const REDEEM_CLOSE_POPUP = "REDEEM_CLOSE_POPUP";
export const REDEEM_OPEN_CONFIRM = "REDEEM_OPEN_CONFIRM";
export const REDEEM_OPEN_FAIL = "REDEEM_OPEN_FAIL";
export const REDEEM_OPEN_SUCCESS = "REDEEM_OPEN_SUCCESS";
export const REDEEM_OPEN_BOOKING_CONFIRM = "REDEEM_OPEN_BOOKING_CONFIRM";
export const REDEEM_REQUEST = "REDEEM_REQUEST";
export const REDEEM_COUNT_SUCCESS = "REDEEM_COUNT_SUCCESS";
export const REDEEM_COUNT = "REDEEM_COUNT";

export const WALLET_SEARCH = "WALLET_SEARCH";
export const WALLET_RESET_SEARCH = "WALLET_RESET_SEARCH";
export const WALLET_COUNT_TOTAL = "WALLET_COUNT_TOTAL";
export const WALLET_LIST_FETCH = "WALLET_LIST_FETCH";
export const WALLET_LIST_FETCH_SUCCESS = "WALLET_LIST_FETCH_SUCCESS";
export const WALLET_DETAIL_CLEAR = "WALLET_DETAIL_CLEAR";
export const WALLET_DETAIL_FETCH = "WALLET_DETAIL_FETCH";
export const WALLET_DETAIL_FETCH_SUCCESS = "WALLET_DETAIL_FETCH_SUCCESS";
export const WALLET_LIST_PROFILE_FETCH = "WALLET_LIST_PROFILE_FETCH";
export const WALLET_TRANSACTION_LIST_FETCH = "WALLET_TRANSACTION_LIST_FETCH";

export const SHOPCODE_CLOSE_POPUP = "SHOPCODE_CLOSE_POPUP";
export const SHOPCODE_OPEN_SUCCESS = "SHOPCODE_OPEN_SUCCESS";
export const SHOPCODE_OPEN_FAIL = "SHOPCODE_OPEN_FAIL";
export const SHOPCODE_REQUEST = "SHOPCODE_REQUEST";

export const WISH_LIST_FETCH = "WISH_LIST_FETCH";
export const WISH_LIST_FETCH_SUCCESS = "WISH_LIST_FETCH_SUCCESS";
export const WISH_LIST_FETCH_RESET = "WISH_LIST_FETCH_RESET";
export const WISH_LIST_SEND_STATUS = "WISH_LIST_SEND_STATUS";

export const SIGNIN_CLOSE_POPUP = "SIGNIN_CLOSE_POPUP";
export const SIGNIN_OPEN_NOT_FOUND = "SIGNIN_OPEN_NOT_FOUND";
export const SIGNIN_OPEN_CONSENT= "SIGNIN_OPEN_CONSENT";
export const SIGNIN_CLOSE_CONSENT= "SIGNIN_CLOSE_CONSENT";
export const SIGNIN_CONSENT_UPDATE = "SIGNIN_CONSENT_UPDATE";
export const SIGNIN_PASSWORD_UPDATE = "SIGNIN_PASSWORD_UPDATE";
export const SIGNIN_OPEN_CHANGE_DEFAULT_PASSWORD = "SIGNIN_OPEN_CHANGE_DEFAULT_PASSWORD";
export const SIGNIN_CLOSE_CHANGE_DEFAULT_PASSWORD = "SIGNIN_CLOSE_CHANGE_DEFAULT_PASSWORD";
export const POPUP_OPEN_TIER_SHOW = "POPUP_OPEN_TIER_SHOW";
export const POPUP_CLOSE_TIER_SHOW = "POPUP_CLOSE_TIER_SHOW";



export const SIGNUP_CLOSE_POPUP = "SIGNUP_CLOSE_POPUP";
export const SIGNUP_OPEN_SUCCESS = "SIGNUP_OPEN_SUCCESS";
export const SIGNUP_OPEN_FAIL = "SIGNUP_OPEN_FAIL";
export const SIGNUP_OPEN_NOTI = "SIGNUP_OPEN_NOTI";


// COUPON 
export const COUPON_SEARCH = "COUPON_search";
export const COUPON_RESET_SEARCH = "COUPON_reset_search";
export const COUPON_COUNT_TOTAL = "COUPON_count_total";
export const COUPON_LIST_FETCH = "COUPON_list_fetch";
export const COUPON_LIST_PROFILE_FETCH = "COUPON_list_profile_fetch";
export const COUPON_LIST_FETCH_SUCCESS = "COUPON_list_fetch_success";
export const COUPON_DETAIL_CLEAR = "COUPON_detail_clearn";
export const COUPON_DETAIL_FETCH = "COUPON_detail_fetch";
export const COUPON_DETAIL_FETCH_SUCCESS = "COUPON_detail_fetch_success";


// Forgot Password
export const FORGOT_PASSWORD = "forgot_password";
export const FORGOT_PASSWORD_SUCCESS = "forgot_password_success";
export const FORGOT_PASSWORD_CHECK = "forgot_password_check";
export const FORGOT_PASSWORD_SET_TOKEN = "forgot_password_set_token";
export const FORGOT_PASSWORD_CHECK_SUCCESS = "forgot_password_check_success";
export const FORGOT_PASSWORD_RESET = "forgot_password_reset";
export const FORGOT_PASSWORD_RESET_SUCCESS = "forgot_password_reset_success";
export const REQUEST_RESET_CLOSE_POPUP = "request_reset_close_popup";
export const REQUEST_RESET_OPEN_SUCCESS = "request_reset_open_success";
export const REQUEST_RESET_OPEN_FAIL = "request_reset_open_fail";
export const RESET_CLOSE_POPUP = "reset_close_popup";
export const RESET_OPEN_SUCCESS = "reset_open_success";
export const RESET_OPEN_FAIL = "reset_open_fail";
